// src/components/Navbar.js

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { Menu, X, LogOut } from 'lucide-react';
import logo from '../assets/images/logo-chef.png';

const Navbar = () => {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // --- CAMBIO DE COLOR AQUÍ ---
  // Cambiamos el color del texto al pasar el mouse en los enlaces de navegación
  const navLinkClass = "block py-2 px-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-orange-500 md:p-0";
  
  // --- CAMBIO DE COLOR AQUÍ ---
  // Cambiamos el color de fondo del botón principal
  const primaryButtonClass = "w-full text-center px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors duration-300";
  
  const secondaryButtonClass = "w-full flex items-center justify-center px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors duration-300";

  return (
    <nav className="bg-white shadow-md fixed w-full z-20 top-0 left-0 border-b border-gray-200">
      <div className="container mx-auto px-6 py-3 flex justify-between items-center">
        <NavLink to="/" className="flex items-center">
          <img src={logo} alt="Logo" className="h-10 w-10 rounded-full" />
          <span className="font-bold text-xl ml-2"></span>
        </NavLink>

        <div className="md:hidden">
          {/* --- CAMBIO DE COLOR AQUÍ --- */}
          {/* Cambiamos el color del ícono de menú al pasar el mouse */}
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-orange-500 focus:outline-none">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        <div className="hidden md:flex items-center space-x-6">
          <NavLink to="/" className={navLinkClass}>Inicio</NavLink>
          <NavLink to="/catalogo" className={navLinkClass}>Catálogo</NavLink>
          <NavLink to="/nosotros" className={navLinkClass}>Nosotros</NavLink>
          <NavLink to="/contacto" className={navLinkClass}>Contacto</NavLink>
        </div>

        <div className="hidden md:flex items-center space-x-3">
            {user ? (
                <>
                    <NavLink to="/portal/resumen" className={primaryButtonClass}>Mi Portal</NavLink>
                    <button onClick={logout} className={secondaryButtonClass.replace('w-full', 'px-3')}>
                        <LogOut size={18} className="mr-2" />
                        Salir
                    </button>
                </>
            ) : (
                <NavLink to="/cuenta" className={primaryButtonClass}>Mi Cuenta</NavLink>
            )}
        </div>
      </div>

      {/* Menú Móvil Actualizado */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-5 pt-2 pb-4 space-y-3">
            <NavLink to="/" className={navLinkClass} onClick={() => setIsOpen(false)}>Inicio</NavLink>
            <NavLink to="/catalogo" className={navLinkClass} onClick={() => setIsOpen(false)}>Catálogo</NavLink>
            <NavLink to="/nosotros" className={navLinkClass} onClick={() => setIsOpen(false)}>Nosotros</NavLink>
            <NavLink to="/contacto" className={navLinkClass} onClick={() => setIsOpen(false)}>Contacto</NavLink>
            <div className="pt-2 space-y-2">
              {user ? (
                <>
                  <NavLink to="/portal/resumen" className={primaryButtonClass} onClick={() => setIsOpen(false)}>Mi Portal</NavLink>
                  <button onClick={() => { logout(); setIsOpen(false); }} className={secondaryButtonClass}>
                      <LogOut className="mr-2" size={20} />
                      Cerrar Sesión
                  </button>
                </>
              ) : (
                <NavLink to="/cuenta" className={primaryButtonClass} onClick={() => setIsOpen(false)}>Mi Cuenta</NavLink>
              )}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;